<template>
  <div class="app-container">
    <BjDivider
      >{{ $t('BusinessStockDistributionRatioAddSku.title') }}
      <template slot="right"
        ><el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t('saveText') }}</el-button>
      </template>
    </BjDivider>

    <el-form ref="form" label-position="top" :model="form" :rules="rules" label-width="120px">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$t('BusinessStockDistributionRatioAddSku.supportWarehouseType')"
            prop="supportWarehouseType"
          >
            <BjSelectLov
              v-model="form.supportWarehouseType"
              constant-key="STOCK_WAREHOUSE_TYPE_SON_4_LIST"
              @change="onChangeSupportWarehouseType"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('BusinessStockDistributionRatioAddSku.supportWarehouseId')"
            prop="supportWarehouseId"
          >
            <BjSelectWarehouse
              v-model="form.supportWarehouseId"
              :type-code="supportTypeCodeList"
              @change="onChangeSupportWarehouseId"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('BusinessStockDistributionRatioAddSku.receiveWarehouseType')"
            prop="receiveWarehouseType"
          >
            <BjInput
              :maxlength="MAX_LENGTH.DEFAULT"
              disabled
              :value="form.receiveWarehouseTypeName"
            />
            <!-- <BjSelectLov
              v-model="form.receiveWarehouseType"
              constant-key="STOCK_WAREHOUSE_TYPE_SON_3_LIST"
              @change="onChangeReceiveWarehouseType"
            /> -->
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('BusinessStockDistributionRatioAddSku.receiveWarehouseId')"
            prop="receiveWarehouseId"
          >
            <BjSelectLov
              v-model="form.receiveWarehouseId"
              :option-list="receiveWarehouseList"
              @change="onChangeReceiveWarehouseId"
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$t('goodsPage.spuCode')" prop="spuCode">
            <BjInput
              v-model="form.spuCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('goodsPage.spuName')" prop="spuName">
            <BjInput
              v-model="form.spuName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$t('BusinessStockDistributionRatioAddSku.categoryId')"
            prop="categoryId"
          >
            <BjGoodsTypeTreeSelect
              v-model="form.categoryId"
              :placeholder="$t('chooseText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('BusinessStockDistributionRatioAddSku.skuCode')" prop="skuCode">
            <BjInput
              v-model="form.skuCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="flex flex-align-end">
        <el-button type="cyan" icon="el-icon-search" @click="onSearch()">{{
          $t('queryText')
        }}</el-button>
        <el-button icon="el-icon-refresh" @click="onReset()">{{ $t('resetText') }}</el-button>
      </div>
    </el-form>
    <el-row type="flex">
      <!-- 左 -->

      <el-col :span="11">
        <p class="title">
          {{ $t('BusinessStockDistributionRatioAddSku.supplyWarehouseList') }}
          <span class="tips">
            {{ $t('BusinessStockDistributionRatioAddSku.warehouseType') }}:{{
              $t('BusinessStockDistributionRatioAddSku.realPosition')
            }}；{{ $t('BusinessStockDistributionRatioAddSku.warehouseCode') }}:{{
              form.supportWarehouseCode
            }}；{{ $t('BusinessStockDistributionRatioAddSku.warehouseName') }}:{{
              form.supportWarehouseName
            }}
          </span>
        </p>

        <vxe-table
          ref="tableSupport"
          :data="tableDataSupport"
          stripe
          border
          :header-cell-style="$rowStyle.DEFAULT"
          :row-config="{ keyField: 'skuCode' }"
          height="400px"
          :empty-text="$t('table.emptyText')"
          :checkbox-config="{ checkMethod: selectableSupport }"
          @scroll="tableSupportScroll"
          @checkbox-all="handleSelectSupportAllEvent"
          @checkbox-change="handleSelectionChangeSupport"
        >
          <vxe-column type="checkbox" align="center" width="55"></vxe-column>
          <!-- <el-table-column
            :selectable="selectableSupport"
            type="selection"
            width="55"
            align="center"
          /> -->
          <el-table-column type="index" width="60" align="center" :label="$t('table.countText')" />
          <el-table-column
            prop="categoryName"
            align="center"
            :label="$t('BusinessStockDistributionRatioAddSku.table.categoryName')"
          />
          <!-- <el-table-column prop="spuCode" align="center" :label="$t('goodsPage.table.spuCode')" />
          <el-table-column prop="spuName" align="center" :label="$t('goodsPage.table.spuName')" /> -->
          <el-table-column
            prop="skuCode"
            align="center"
            :label="$t('BusinessStockDistributionRatioAddSku.table.skuCode')"
          />
          <!-- <el-table-column prop="qty" label="仓位数量" /> -->
        </vxe-table>
      </el-col>

      <!-- 中 -->

      <el-col :span="2" class="flex-box-center">
        <div class="button-arrow" @click="onSupport2ReceiveFn">
          <i class="el-icon-arrow-right" />
          <span>{{ $t('BusinessStockDistributionRatioAddSku.distribute') }}</span>
        </div>
        <div class="button-arrow" @click="onReceive2SupportFn">
          <i class="el-icon-arrow-left" />
          <span>{{ $t('BusinessStockDistributionRatioAddSku.withdraw') }}</span>
        </div>
      </el-col>

      <!-- 右 -->

      <el-col :span="11">
        <p class="title">
          {{ $t('BusinessStockDistributionRatioAddSku.receivingWarehouseList') }}
          <span class="tips">
            {{ $t('BusinessStockDistributionRatioAddSku.warehouseType') }}:{{
              form.receiveWarehouseTypeName
            }}；{{ $t('BusinessStockDistributionRatioAddSku.warehouseCode') }}:{{
              form.receiveWarehouseCode
            }}；{{ $t('BusinessStockDistributionRatioAddSku.warehouseName') }}:{{
              form.receiveWarehouseName
            }}
          </span>

          <!-- <el-button  type="primary" @click="setQty">批量设置</el-button> -->

          <el-button type="primary" @click="onSet">{{
            $t('BusinessStockDistributionRatioAddSku.warehouseStructureRatio')
          }}</el-button>
        </p>
        <vxe-table
          ref="tableReceive"
          :data="tableDataReceive"
          stripe
          border
          :header-cell-style="$rowStyle.DEFAULT"
          :row-config="{ keyField: 'skuCode' }"
          height="400px"
          :empty-text="$t('table.emptyText')"
          @scroll="tableReceiveScroll"
          @checkbox-all="handleSelectReceiveAllEvent"
          @checkbox-change="handleSelectionChangeReceive"
        >
          <vxe-column type="checkbox" align="center" width="55"></vxe-column>
          <el-table-column type="index" width="60" align="center" :label="$t('table.countText')" />
          <el-table-column
            prop="categoryName"
            align="center"
            :label="$t('BusinessStockDistributionRatioAddSku.table.categoryName')"
          />
          <!-- <el-table-column prop="spuCode" align="center" :label="$t('goodsPage.spuCode')" />
          <el-table-column prop="spuName" align="center" :label="$t('goodsPage.spuName')" /> -->
          <el-table-column
            prop="skuCode"
            align="center"
            :label="$t('BusinessStockDistributionRatioAddSku.table.skuCode')"
          />
          <!-- <el-table-column prop="qty" label="仓位数量">
            <template slot-scope="props">
              <BjInput :maxlength="MAX_LENGTH.DEFAULT"    v-model="props.row.qty"  />
            </template>
          </el-table-column> -->
        </vxe-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import ElTableColumn from '@/components/ElTableColumn/index.vue';
import viewMiXin from '@/utils/view-mixin.js';
import { stockApi } from '@/api';
const DEFAULT_PAGE = 1;
const DEFAULT_SIZE = 1000; // 大一点，要超过高度必须
const getDefaultForm = () => {
  return {
    supportWarehouseId: null,
    supportWarehouseType: null,
    supportWarehouseTypeName: null,
    supportWarehouseCode: null,
    supportWarehouseName: null,

    receiveWarehouseId: null,
    receiveWarehouseType: null,
    receiveWarehouseTypeName: null,
    receiveWarehouseCode: null,
    receiveWarehouseName: null,

    categoryId: null,
    skuCode: null,
    spuCode: null,
    spuName: null,
  };
};
export default {
  name: 'BusinessStockDistributionRatioAddSku',
  components: { ElTableColumn },
  mixins: [viewMiXin],
  data() {
    return {
      form: getDefaultForm(),
      rules: {
        supportWarehouseType: [
          { required: true, message: this.$t('chooseText'), trigger: 'change' },
        ],
        receiveWarehouseType: [
          { required: true, message: this.$t('chooseText'), trigger: 'change' },
        ],
        receiveWarehouseId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        supportWarehouseId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
      selectedRowSupport: [],
      tableDataSupport: [],

      selectedRowReceive: [],
      tableDataReceive: [],

      receiveWarehouseList: [],

      // receivePage: DEFAULT_PAGE,
      // receiveEnd: false,
      size: DEFAULT_SIZE,

      ScrollSupport: null,
      ScrollReceive: null,
    };
  },
  computed: {
    supportTypeCodeList() {
      return this.form.supportWarehouseType ? [this.form.supportWarehouseType] : null;
    },
  },
  watch: {
    'form.supportWarehouseType'() {
      this.form.supportWarehouseId = null;
    },
    'form.receiveWarehouseType'() {
      this.form.receiveWarehouseId = null;
      this.getReceiveWarehouse();
    },
    'form.supportWarehouseId'() {
      this.form.receiveWarehouseId = null;
      this.getReceiveWarehouse();
    },
  },

  mounted() {
    this.ScrollSupport = new this.$ScrollLoad(this.loadSupport, {
      // el: this.$refs.tableSupport.bodyWrapper,
      page: DEFAULT_PAGE,
    });
    this.ScrollReceive = new this.$ScrollLoad(this.loadReceive, {
      // el: this.$refs.tableReceive.bodyWrapper,
      page: DEFAULT_PAGE,
    });
  },

  methods: {
    // 跳转到仓库结构设置
    onSet() {
      stockApi.getWarehouseStructureId().then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$toPage('SettingStockRatioConfig', { structureId: res.id });
        }
      });
    },

    // 批量设置
    // setQty() {
    //   if (this.selectedRowReceive.length == 0) {
    //     this.$message.warning('请选择 右侧 接收仓 商品');
    //     return;
    //   }
    //   this.$prompt('请输入仓位数量', '批量设置仓位数量', {
    //     confirmButtonText: this.$t('toast.okText'),
    //     cancelButtonText: this.$t('toast.cancelText'),
    //     inputPattern: /^[0-9]+$/,
    //     inputErrorMessage: '数量格式不正确',
    //     closeOnClickModal: false,
    //   })
    //     .then(({ value }) => {
    //       this.tableDataReceive.map(row => {
    //         row.qty = Number(value || 0);
    //       });
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '取消输入',
    //       });
    //     });
    // },
    // 供货仓多选：可选逻辑
    selectableSupport({ row, index }) {
      return !this.tableDataReceive.find(e => e.skuCode === row.skuCode);
    },
    // 分配 按钮 onSupport2ReceiveFn
    onSupport2ReceiveFn() {
      if (this.selectedRowSupport.length <= 0) {
        this.$message.warning(this.$t('BusinessStockDistributionRatioAddSku.msgWarning1'));
        return;
      }
      this.selectedRowSupport.forEach(row => {
        if (!this.tableDataReceive.find(e => e.skuCode === row.skuCode)) {
          this.tableDataReceive.push({
            ...row,
            qty: 0,
          });
        }
      });

      this.$refs.tableSupport.clearCheckboxRow();
    },
    // 撤回 按钮 onReceive2SupportFn
    onReceive2SupportFn() {
      if (this.selectedRowReceive.length <= 0) {
        this.$message.warning(this.$t('BusinessStockDistributionRatioAddSku.setQtyMsg1'));
        return;
      }
      this.selectedRowReceive.forEach(row => {
        this.tableDataReceive.splice(
          this.tableDataReceive.findIndex(e => e.skuCode == row.skuCode),
          1,
        );
      });
      this.deleteApi({
        ids: this.selectedRowReceive.filter(e => e.id).map(e => e.id),
      });
      this.$refs.tableReceive.clearCheckboxRow();
    },
    // 点击查询
    onSearch(i, j) {
      this.tableDataSupport = [];
      this.tableDataReceive = [];

      this.ScrollSupport.init();
      this.ScrollReceive.init();

      this.loadSupport(i || DEFAULT_PAGE);
      this.loadReceive(j || DEFAULT_PAGE);
    },
    // 点击重置
    onReset() {
      this.form = getDefaultForm();
      this.tableDataSupport = [];
      this.tableDataReceive = [];
      this.ScrollSupport.isEnd = false;
      this.receiveEnd = false;
      this.ScrollSupport.page = 0;
      this.receivePage = 0;
    },
    onChangeSupportWarehouseType(v, item) {
      this.form.supportWarehouseTypeName = item.label;
      // 实仓 =》 比例虚仓
      // 比例虚仓 =》 渠道仓
      if (v === 'real') {
        this.form.receiveWarehouseType = 'ratio-virtual';
        this.form.receiveWarehouseTypeName = '比例虚仓';
      } else if (v === 'ratio-virtual') {
        this.form.receiveWarehouseType = 'channel';
        this.form.receiveWarehouseTypeName = '渠道仓';
      } else {
        this.form.receiveWarehouseType = '';
        this.form.receiveWarehouseTypeName = '';
      }
    },
    // 供货仓选择 的回调
    onChangeSupportWarehouseId(v, item) {
      this.form.supportWarehouseCode = item.code;
      this.form.supportWarehouseName = item.name;
    },
    // 接收仓选择 的回调
    onChangeReceiveWarehouseId(v, item) {
      this.form.receiveWarehouseCode = item.code;
      this.form.receiveWarehouseName = item.name;
    },

    handleSelectSupportAllEvent() {
      const records = this.$refs.tableSupport.getCheckboxRecords();
      this.handleSelectionChangeSupport({ records });
    },
    handleSelectReceiveAllEvent() {
      const records = this.$refs.tableReceive.getCheckboxRecords();
      this.handleSelectionChangeReceive({ records });
    },
    handleSelectionChangeSupport({ records: data }) {
      this.selectedRowSupport = [].concat(data);
    },
    handleSelectionChangeReceive({ records: data }) {
      this.selectedRowReceive = [].concat(data);
    },
    // 保存
    handleConfirm() {
      if (this.tableDataReceive.length == 0) {
        this.$message.warning(this.$t('BusinessStockDistributionRatioAddSku.msgWarning2'));
        return;
      }
      const API_DATA = {
        freightSpaceList: this.tableDataReceive.map(e => {
          return {
            // qty: Number(e.qty || 0),
            skuId: e.skuId,
            skuCode: e.skuCode,
          };
        }),
        receiveWarehouseId: this.form.receiveWarehouseId,
        supportWarehouseId: this.form.supportWarehouseId,
      };

      this.$refs['form'].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        if (this.isEdit) {
          this.updateApi(API_DATA);
        } else {
          this.addApi(API_DATA);
        }
      });
    },
    loadSupport(i) {
      if (i === undefined) {
        i = this.ScrollSupport.page();
      }
      this.$refs['form'].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        this.getGoodsSupport({
          categoryId: this.form.categoryId,
          skuCode: this.form.skuCode,
          spuCode: this.form.spuCode,
          spuName: this.form.spuName,
          supportWarehouseId: this.form.supportWarehouseId,
          page: i,
          size: this.size,
        });
      });
    },
    loadReceive(j) {
      if (j === undefined) {
        j = this.ScrollReceive.page();
      }
      this.$refs['form'].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        this.getGoodsReceive({
          categoryId: this.form.categoryId,
          skuCode: this.form.skuCode,
          spuCode: this.form.spuCode,
          spuName: this.form.spuName,
          receiveWarehouseId: this.form.receiveWarehouseId,
          supportWarehouseId: this.form.supportWarehouseId,
          page: j,
          size: this.size,
        });
      });
    },
    tableSupportScroll(row) {
      this.ScrollSupport.scrollEvent(row.$event);
    },
    tableReceiveScroll(row) {
      this.ScrollReceive.scrollEvent(row.$event);
    },
    getGoodsSupport(API_DATA) {
      stockApi.getMayDistributeSpacesGoods(API_DATA).then(res => {
        this.ScrollSupport.maxPage(res.totalPages); // 最大页码，控制滚动加载
        this.ScrollSupport.page(true); // 下一页
        if (res.number === 0) {
          this.tableDataSupport = res.content || [];
        } else {
          this.tableDataSupport = this.tableDataSupport.concat(res.content || []);
        }
      });
    },
    getGoodsReceive(API_DATA) {
      stockApi.getDistributeSpacesGoods(API_DATA).then(res => {
        this.ScrollReceive.maxPage(res.totalPages); // 最大页码，控制滚动加载
        this.ScrollReceive.page(true); // 下一页
        if (res.number === 0) {
          this.tableDataReceive = res.content || [];
        } else {
          this.tableDataReceive = this.tableDataReceive.concat(res.content || []);
        }
      });
    },
    // 接收仓的仓库列表
    getReceiveWarehouse() {
      if (!this.form.receiveWarehouseType || !this.form.supportWarehouseId) {
        return;
      }
      stockApi
        .getReceiveWarehouse({
          receiveTypeCode: this.form.receiveWarehouseType,
          supportWarehouseId: this.form.supportWarehouseId,
          page: 0,
          size: 1000,
        })
        .then(res => {
          this.receiveWarehouseList = (res.content || []).map(e => {
            return {
              label: e.name,
              value: e.id,
            };
          });
        });
    },

    addApi(API_DATA) {
      stockApi.addDistributeSpacesRatio(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.complete('BusinessStockDistributionRatioIndex');
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      this.addApi(API_DATA);
    },
    deleteApi(API_DATA) {
      stockApi.deleteDistributeSpacesGoods(API_DATA).then(res => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 14px;
  font-weight: 400;
}
.flex-box-center {
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding-top: 30px;
}
.button-arrow {
  width: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px auto;
  cursor: pointer;
  font-size: 14px;
  i {
    font-size: 32px;
    font-weight: bold;
  }
}
.el-form-item {
  margin-bottom: 16px;
}
</style>
